module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectSmallBlackH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectSmallBlackH.png
// module id = 242
// module chunks = 0